import React from 'react';
import { PRODUCT_DISCOVERY_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import ShortcutScope from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcut-scope.tsx';
import { useFormContext } from '@atlassian/jira-issue-create-form-context/src/index.tsx';
import type { WatchersConfig } from '@atlassian/jira-issue-create-watchers/src/services/types.tsx';
import WatchersApp from '@atlassian/jira-issue-create-watchers/src/ui/async.tsx';
import BaseTriggerButton from '@atlassian/jira-issue-create-watchers/src/ui/watchers-trigger-button/base-button/index.tsx';
import { useCurrentUser } from '@atlassian/jira-platform-services-user-current/src/main.tsx';
import type { ControllerFull } from '@atlassian/jira-platform-services-user-current/src/types.tsx';

type Props = {
	configs?: WatchersConfig;
	shouldRenderInDropdown?: boolean;
};

const Watchers = ({ configs, shouldRenderInDropdown }: Props) => {
	const { isWatchersEnabled } = configs || {};

	const {
		data: { user: currentUser },
		loading,
		error,
	} = useCurrentUser() as ControllerFull; // eslint-disable-line @typescript-eslint/consistent-type-assertions

	const [{ watchers, selectedProject }, { setWatchers }] = useFormContext();

	const shouldShowWatchers =
		selectedProject &&
		configs &&
		!currentUser.isAnonymous &&
		!loading &&
		!error &&
		// NOTE: JPD has no ability to manage watchers at the time of release, this is a workaround to prevent watchers being added for JPD.
		selectedProject.projectType !== PRODUCT_DISCOVERY_PROJECT;

	const isWatching = watchers.some((watcher) => watcher.accountId === currentUser.accountId);

	if (!shouldShowWatchers || (!isWatchersEnabled && shouldRenderInDropdown)) return null;

	if (!isWatchersEnabled) return <BaseTriggerButton isDisabled />;

	return (
		<ShortcutScope>
			<WatchersApp
				watchers={watchers}
				projectKey={selectedProject.projectKey}
				setWatchers={setWatchers}
				isWatching={isWatching}
				currentUser={currentUser}
				shouldRenderInDropdown={shouldRenderInDropdown}
				{...configs}
			/>
		</ShortcutScope>
	);
};

export default Watchers;
